import { TextInputField, Button, Pane, majorScale, toaster, Select, FormField, Heading, Text, DocumentIcon } from 'evergreen-ui';
import { updateCollaborator, getUserDetails, deleteUserAttachment } from '../services/collaboratorServices';
import { useState, useEffect } from 'react';
import { ConfirmIcon, CrossIcon } from 'evergreen-ui';
import { useAuth } from '../services/authContext';

const EditCollaboratorForm = ({ editedCollaborator, handleCancelEdit, fetchCollaborators }) => {
    const { user } = useAuth();
    const [localCollaborator, setLocalCollaborator] = useState({ ...editedCollaborator });
    const [attachments, setAttachments] = useState([]);

    const fetchAttachments = async (userId) => {
        try {
            const data = await getUserDetails(userId);
            if (data && data.attachments) {
                setAttachments(data.attachments);
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        setLocalCollaborator((prev) => ({
            ...prev,
            id: editedCollaborator.id || prev.id,
        }));
        if (editedCollaborator.id) {
            fetchAttachments(editedCollaborator.id);
        }
    }, [editedCollaborator]);

    const handleConfirmEdit = async () => {
        try {
            if (!localCollaborator.role || localCollaborator.role.trim() === '') {
                localCollaborator.role = 'operatore';
            }

            const resultUpdate = await updateCollaborator(localCollaborator);
            if (resultUpdate.success) {
                await fetchCollaborators();
                toaster.success('Collaboratore modificato con successo.');
                handleCancelEdit();
            } else {
                toaster.danger('Errore durante l\'aggiornamento del collaboratore.');
            }
        } catch (error) {
            console.error('Errore nella modifica del collaboratore:', error);
            toaster.danger('Errore nella modifica del collaboratore.');
        }
    };

    const handleCancel = () => {
        setLocalCollaborator({ ...editedCollaborator });
        handleCancelEdit();
    };

    const handleInputChange = (field, value) => {
        setLocalCollaborator((prev) => ({
            ...prev,
            [field]: value || "", 
        }));
    };

    const handleDeleteAttachment = async (attachmentId) => {
        if (!window.confirm("Sei sicuro di voler eliminare questo allegato?")) return;
        
        try {
            const resp = await deleteUserAttachment(attachmentId);
            if (resp && resp.success) {
                toaster.success('Allegato eliminato.');
                fetchAttachments(localCollaborator.id);
            } else {
                toaster.danger("Errore durante l'eliminazione.");
            }
        } catch (err) {
            console.error(err);
            toaster.danger("Errore di rete.");
        }
    };

    return (
        <Pane>
            <TextInputField
                label="Email"
                value={localCollaborator.email || ""}
                onChange={(e) => handleInputChange("email", e.target.value)}
                marginBottom={16}
            />
            <TextInputField
                label="Password"
                value={localCollaborator.password || ""}
                onChange={(e) => handleInputChange("password", e.target.value)}
                marginBottom={16}
            />
            <TextInputField
                label="Nome"
                value={localCollaborator.nome || ""}
                onChange={(e) => handleInputChange("nome", e.target.value)}
                marginBottom={16}
            />
            <TextInputField
                label="Cognome"
                value={localCollaborator.cognome || ""}
                onChange={(e) => handleInputChange("cognome", e.target.value)}
                marginBottom={16}
            />
            <FormField
                label="Ruolo"
                marginBottom={16}
            >
                <Select
                    id="role-select"
                    value={localCollaborator.role || "operatore"}
                    onChange={(e) => handleInputChange("role", e.target.value)}
                >
                    <option value="operatore">Operatore</option>
                    <option value="educatore">Educatore</option>
                </Select>
            </FormField>

            {user?.role === 'direttore' && attachments.length > 0 && (
                <Pane marginTop={16} padding={8} background="tint2" borderRadius={4}>
                    <Heading size={400} marginBottom={8}>Allegati presenti</Heading>
                    <ul style={{ paddingLeft: 20, margin: 0 }}>
                        {attachments.map(att => (
                            <li key={att.id} style={{ marginBottom: 4 }}>
                                <Pane display="flex" alignItems="center" gap={8}>
                                    <Text><a href={att.file_path} target="_blank" rel="noopener noreferrer"><DocumentIcon size={12} /> {att.file_name}</a></Text>
                                    <Text
                                        color="danger"
                                        cursor="pointer"
                                        textDecoration="underline"
                                        onClick={() => handleDeleteAttachment(att.id)}
                                        size={300}
                                    >
                                        Elimina
                                    </Text>
                                </Pane>
                            </li>
                        ))}
                    </ul>
                </Pane>
            )}

            <Pane display="flex" justifyContent="space-between" marginTop={majorScale(4)}>
                <Button appearance="primary" intent="success" onClick={handleConfirmEdit}>
                    Conferma modifica <ConfirmIcon marginLeft={8} />
                </Button>
                <Button intent="danger" onClick={handleCancel}>
                    Annulla <CrossIcon marginLeft={8} />
                </Button>
            </Pane>
        </Pane>
    );
};

export default EditCollaboratorForm;